import { ANNOUNCEMENT_CARD_TEMPLATE } from '../../../types/WhatsNew.js';

const WHATS_NEW_DIALOGS = [
    {
        key: "tracked_competitors",
        name: "Tracked Competitors",
        changeType: "new",
        headline: "See where you rank against",
        headlineHighlight: "Tracked Competitors",
        description: "Pick the competitors that matter and follow how your visibility compares, engine by engine.",
    },
];
/**
 * The API's "announcement_card": a card with nothing written on it, so an announcement shows only the
 * words written for it, never a built-in pop-up's.
 */
const ANNOUNCEMENT_CARD_DIALOG = {
    key: ANNOUNCEMENT_CARD_TEMPLATE,
    name: "Announcement",
    changeType: "new",
    headline: "",
    description: "",
};
/** The pop-up a key names, if this build has it. */
const getWhatsNewDialog = (key) => {
    var _a;
    return (_a = WHATS_NEW_DIALOGS.find((dialog) => dialog.key === key)) !== null && _a !== void 0 ? _a : (key === ANNOUNCEMENT_CARD_TEMPLATE ? ANNOUNCEMENT_CARD_DIALOG : undefined);
};
/** A whole headline, highlight included: a pop-up's, or a slide's (`SlideWords`). */
const fullHeadlineOf = ({ headline, headlineHighlight }) => [headline, headlineHighlight].filter(Boolean).join(" ");
/** The whole headline, highlight included: for the drawer, the admin list and titles. None for the API's card. */
const getWhatsNewDialogHeadline = (key) => {
    const dialog = getWhatsNewDialog(key);
    return (dialog && fullHeadlineOf(dialog)) || undefined;
};
/**
 * A slide's words: the announcement's own headline and description when it has them (written in the
 * admin form, sent back in `content`), else its pop-up's. A headline written exactly as the pop-up's
 * keeps its highlighted end.
 */
const getSlideWords = (item, dialog) => {
    var _a, _b, _c, _d;
    const written = (_b = (_a = item.content) === null || _a === void 0 ? void 0 : _a.headline) === null || _b === void 0 ? void 0 : _b.trim();
    const description = ((_d = (_c = item.content) === null || _c === void 0 ? void 0 : _c.description) === null || _d === void 0 ? void 0 : _d.trim()) || dialog.description;
    if (written && written !== fullHeadlineOf(dialog))
        return { headline: written, description };
    return { headline: dialog.headline, headlineHighlight: dialog.headlineHighlight, description };
};
/** What an announcement goes by in the admin: the headline written in its form, else its pop-up's. */
const getAnnouncementHeadline = (headline, template) => (headline === null || headline === void 0 ? void 0 : headline.trim()) || getWhatsNewDialogHeadline(template);
/** A pop-up published before this build knew its key is skipped rather than drawn wrong. */
const isRenderableTemplate = (template) => Boolean(getWhatsNewDialog(template));
/**
 * What a customer can be shown: a pop-up this build knows, with something written to show. An
 * announcement card that reached them with no words at all is skipped rather than drawn blank.
 */
const isShowableItem = (item) => {
    const dialog = getWhatsNewDialog(item.template);
    if (!dialog)
        return false;
    const words = getSlideWords(item, dialog);
    return Boolean(fullHeadlineOf(words) || words.description);
};

export { ANNOUNCEMENT_CARD_DIALOG, WHATS_NEW_DIALOGS, fullHeadlineOf, getAnnouncementHeadline, getSlideWords, getWhatsNewDialog, getWhatsNewDialogHeadline, isRenderableTemplate, isShowableItem };
